import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import "@/assets/Style/index.css";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
const app = createApp(App);
// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
import i18nConfig from "./locales";
app.use(i18nConfig);
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.mount("#app");

// 开发环境和生产环境的特定配置
if (process.env.NODE_ENV === "development") {
  // 开发环境配置（如果有的话）
} else {
  // 生产环境配置：禁用 console.log
  if (window) {
    window.console.log = function () {};
  }
}
